import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function KpiItem({ title, value, unit, icon, subtitle, link, linkTitle }) {
  const { t } = useTranslation();
  const hasLink = Boolean(link && linkTitle);

  return (
    <div className="dashboard-kpi-item">
      <div className="dashboard-kpi-item-top">
        <div className="dashboard-kpi-item-icon">{icon}</div>
        <div className="dashboard-kpi-item-value">
          <span className="dashboard-kpi-item-number">{value}</span>
          {unit ? <span className="dashboard-kpi-item-unit">{unit}</span> : null}
        </div>
      </div>
      <div className="dashboard-kpi-item-text">
        <span>{t(title)}</span>
        {subtitle ? <small>{subtitle}</small> : null}
        {hasLink ? (
          <Link to={link} className="dashboard-kpi-item-link">
            {t(linkTitle)}
          </Link>
        ) : (
          <span className="dashboard-kpi-item-link placeholder">&nbsp;</span>
        )}
      </div>
    </div>
  );
}
